import requester from '@/lib/axios';
import {
  BlockCodeActivityEditElement,
  BlockCodeActivityElement,
} from '@/models/_deprecated/ActivityElement';
import { ActivityValidationResult } from '@/data/services/activityElement/codeEditorActivityServices';

export const getBlockActivity = async (questionId: number) => {
  const { data: block } = await requester().get<BlockCodeActivityElement>(
    `block-activity/${questionId}/`,
  );
  return block;
};

export const deleteBlockActivity = async (questionId: number) => {
  await requester().delete<BlockCodeActivityElement>(
    `block-activity/${questionId}/`,
  );
};

export const createBlockActivity = async (
  block: Omit<BlockCodeActivityEditElement, 'id'>,
) => {
  const { data: newBlock } =
    await requester().post<BlockCodeActivityEditElement>(
      `block-activity/`,
      block,
    );
  return newBlock;
};

export const updateBlockActivity = async (
  id: number,
  block: Partial<BlockCodeActivityEditElement>,
) => {
  const { data: updatedBlock } =
    await requester().patch<BlockCodeActivityEditElement>(
      `block-activity/${id}/`,
      block,
    );
  return updatedBlock;
};

export const validateBlockActivity = async (questionId: number) => {
  const { data } = await requester().patch<ActivityValidationResult>(
    `block-activity/${questionId}/validate/`,
  );
  return data;
};
